import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

/**
 * Client OIDC public sur le realm `elika` de Keycloak.
 *
 * Aucun secret ici : le navigateur ne peut rien garder de confidentiel. La
 * sécurité repose sur PKCE (S256) et sur la liste blanche de redirections
 * déclarée côté Keycloak.
 *
 * Flux par redirection et non par popup, comme les autres applications
 * internes : le popup imposerait une page de rappel statique supplémentaire et
 * se fait bloquer par certains navigateurs.
 */
export const oidcConfig = {
  authority: process.env.REACT_APP_KEYCLOAK_ISSUER,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'costcloud',
  redirect_uri: `${window.location.origin}/`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  // Le jeton de session opaque prend le relais après l'échange : inutile de
  // garder une session OIDC vivante côté navigateur.
  automaticSilentRenew: false,
  loadUserInfo: false,
  // sessionStorage : la session tombe à la fermeture de l'onglet.
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
};

export const userManager = new UserManager(oidcConfig);

/** Vrai si l'URL courante est le retour de redirection Keycloak. */
export const isRedirectCallback = () => {
  const params = new URLSearchParams(window.location.search);
  return params.has('code') && params.has('state');
};

/** Retire les paramètres OIDC de la barre d'adresse après l'échange. */
export const cleanCallbackUrl = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
